import type { SVGProps } from 'react'

export const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    viewBox="0 0 10 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.261676 9.73626C0.0941622 9.89757 6.10352e-05 10.1163 6.10352e-05 10.3444C6.10352e-05 10.5725 0.0941622 10.7912 0.261676 10.9525L0.893494 11.5606C1.06109 11.7219 1.28835 11.8124 1.52531 11.8124C1.76227 11.8124 1.98953 11.7219 2.15713 11.5606L5.00003 8.82434L3.10457 6.99997L0.261676 9.73626ZM9.73838 3.04743L9.10656 2.4393C8.93896 2.27807 8.7117 2.1875 8.47474 2.1875C8.23778 2.1875 8.01052 2.27807 7.84293 2.4393L5.00003 5.17559L6.89548 6.99997L9.73838 4.26368C9.90589 4.10237 10 3.88363 10 3.65555C10 3.42748 9.90589 3.20874 9.73838 3.04743Z"
      fill="currentColor"
      opacity="0.4"
    />
    <path
      d="M9.73838 9.73626C9.90589 9.89757 10 10.1163 10 10.3444C10 10.5725 9.90589 10.7912 9.73838 10.9525L9.10656 11.5606C8.93896 11.7219 8.7117 11.8124 8.47474 11.8124C8.23778 11.8124 8.01052 11.7219 7.84293 11.5606L0.261676 4.26368C0.0941622 4.10237 6.10352e-05 3.88363 6.10352e-05 3.65555C6.10352e-05 3.42748 0.0941622 3.20874 0.261676 3.04743L0.893494 2.4393C1.06109 2.27807 1.28835 2.1875 1.52531 2.1875C1.76227 2.1875 1.98953 2.27807 2.15713 2.4393L9.73838 9.73626Z"
      fill="currentColor"
    />
  </svg>
)
